/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `WizardDirectionType*`'s.
 */
export type WizardDirectionType = WizardDirectionTypeNext | WizardDirectionTypePrevious;

/**
 * The Wizard next step direction type.
 */
export type WizardDirectionTypeNext = typeof WIZARD_DIRECTION_NEXT;

/**
 * The Wizard previous step direction type.
 */
export type WizardDirectionTypePrevious = typeof WIZARD_DIRECTION_PREVIOUS;

/**
 * The Wizard next step direction constant.
 */
export const WIZARD_DIRECTION_NEXT = `next`;

/**
 * The Wizard previous step direction constant.
 */
export const WIZARD_DIRECTION_PREVIOUS = `previous`;
